module.exports = __webpack_public_path__ + "img/illu-tulip.1fa62654.svg";